export default {
	'address.TheShippingAddressCannotBeEmpty': '收货地址不能为空！',
	'address.NameIsNotLegal': '姓名不合法',
	'address.EnterTheMobilePhoneNumberAreaCode': '输选择手机号区域号',
	'address.EnterTheCorrectPhoneNumber': '输入正确手机号',
	'address.PleaseSelectARegion': '请选择地区',
	'address.AddressesCannotContainIllegalCharacters': '地址不能包含非法字符',
	'address.PleaseEnterTheCertificateNumberCorrectly': '请正确输入证件号',
	'address.MyAddressPageDefaultAddressSwitch': '我的地址页_默认地址开关',
	'address.MyAddressPageSaveAndUse': '我的地址页_保存并使用',
	'address.TheOperationFailed': '操作失败了',
	'address.OperationSuccessful': '操作成功！',
	'address.ParameterError': '参数错误',
	'address.MyAddressPageDeleteAddress': '我的地址页_删除地址',
	'address.DeleteFailed': '删除失败了',
	'address.PleaseEnterTheConsigneeName': '请输入收货人姓名',
	'address.TheNameOfTheConsigneeShallNotExceed20Characters': '收货人姓名不超过20字',
	'address.TheNameOfTheConsignee': '收货人姓名',
	'address.name': '姓名',
	'address.PleaseEnterYourPhoneNumber': '请输入手机号',
	'address.ContactNumber': '联系电话',
	'address.SelectAStateOrMunicipality': '选择省市自治区',
	'address.Region': '所在地区',
	'address.TheTypeOfCredential': '证件类型',
	'address.PleaseEnterTheIdNumber': '请输入证件号',
	'address.DetailedAddress': '详细地址',
	'address.SuchAsTheCommunityBuildingNumberHouseNumberEtc': '如小区、楼栋号、门牌号等…',
	'address.PleaseEnterYourFullAddress': '请输入详细地址',
	'address.StreetDoorNumbersDoNotExceed100Words': '街道门牌不超过100字',
	'address.SetToTheDefaultAddress': '设为默认地址',
	'address.SetToDefaultAddressNextTimeAfterDefaultingToUseTheAddress':
		'设为默认地址后下次默认使用该地址',
	'address.DeleteAnAddress': '删除地址',
	'address.SaveAndUse': '保存并使用'
};
